import { ErrorIcon, Modal } from 'components/common'
import { ModalRef } from 'components/common/Modal/Modal'
import React, { forwardRef } from 'react'

type Props = {
  buttonNode: React.ReactElement
}

const DifferentBusinessErrorModal = forwardRef<ModalRef, Props>(
  ({ buttonNode }, ref) => {
    return (
      <Modal
        ref={ref}
        className="flex-col w-[400px] h-[300px] flex justify-evenly items-center px-8 py-[20px]"
      >
        <ErrorIcon className="w-[40px] h-[40px]" />

        <p className="text-center font-bold">
          You cannot add item from different restaurant than what's inside of
          cart.
        </p>

        {buttonNode}
      </Modal>
    )
  }
)

export default DifferentBusinessErrorModal
